module.exports = __webpack_public_path__ + "img/logo_head.d5dbe21e.svg";